module.exports = __webpack_public_path__ + "static/img/background.19c02e32.svg";